<template>
  <div class="workbench">
    <div class="content">
      <img src="~@/assets/logo.svg" class="logo" />
      <h1>SQL 学习与分享平台</h1>
      <a @click="handleIntrodution">快速上手</a>
      <a-input-search class="search mgb-24" size="large" @search="onSearch" placeholder="输笔记关键字进行搜索">
        <div slot="addonBefore" class="addon" v-if="!isMobile">&nbsp;&nbsp;笔记搜索&nbsp;&nbsp;</div>
        <a-button slot="enterButton" type="primary">搜索<a-icon type="search"></a-icon></a-button>
      </a-input-search>
      <div :class="['flex', isMobile ? 'isMobile' : '']">
        <div class="button" @click="handleInfoNote">
          <div>
            <a-icon type="experiment" class="mgr-8"></a-icon>
            <p>崖山实验室</p>
          </div>
          <div class="flex">
            <p v-if="!isMobile">在线执行SQL&nbsp;&nbsp;</p>
            <p>></p>
          </div>
        </div>
        <div style="width: 2vw"></div>
        <a-col class="button" @click="handleRepository">
          <div>
            <a-icon type="read" class="mgr-8"></a-icon>
            <p>笔记广场</p>
          </div>
          <div class="flex">
            <p v-if="!isMobile">探索SQL笔记&nbsp;&nbsp;</p>
            <p>></p>
          </div>
        </a-col>
      </div>
      <a-button shape="round" size="large" @click="handleAI" icon="robot" style="margin-top: 2.5vh">智能问答</a-button>
    </div>
    <div class="footer">
      <span> 2024 YashanDB · {{ version }}, running {{ yashandb_version }} &nbsp;&nbsp;</span>
      <div v-if="!isMobile">
        <a href="https://doc.yashandb.com/" target="_blank">文档中心</a> ·
        <a href="https://www.yashandb.com/learning_center" target="_blank">培训认证</a> ·
        <a href="https://www.yashandb.com/service" target="_blank">服务支持</a> ·
        <a href="https://www.yashandb.com/" target="_blank">官方网站</a>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Workbench',
  data() {
    return {
      notes: 'notes',
      isMobile: false,
      version: process.env.VUE_APP_VERSION,
      yashandb_version: process.env.VUE_APP_YASHANDB_VERSION,
    }
  },
  watch: {
    '$store.state.app.isMobile': {
      handler: function (newVal, oldVal) {
        this.isMobile = newVal
      },
    },
  },
  methods: {
    handleAI() {
      var newTab = window.open('about:blank')
      newTab.location.href = 'https://chat.yashandb.com/'
    },
    onSearch(val, e) {
      if (this.notes == 'notes') {
        this.$router.push({ name: 'Repository', params: { search: val } })
      } else {
      }
    },
    handleInfoNote(e, noteId) {
      if (noteId !== undefined) {
        localStorage.setItem('CURRENT_NOTE_ID', noteId)
        this.$store.commit('SET_NOTE_ID', noteId)
      }
      if (this.$route.name !== 'Console' && this.$route.name !== 'Schema') {
        this.$router.push({ name: 'Console' })
      }
    },
    handleIntrodution() {
      this.handleInfoNote(undefined, '-1')
    },
    handleRepository() {
      this.$router.push({ name: 'Repository' })
    },
  },
}
</script>
<style lang="less" scoped>
.workbench {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  background: #f0f2f5 url(~@/assets/workbench_background.png) no-repeat;
  background-size: 100%;
  .content {
    flex: 1;
    display: flex;
    align-items: center;
    flex-direction: column;
    .logo {
      margin-top: 14vh;
      width: 120px;
      height: 120px;
      margin-bottom: 1.5vh;
    }
    h1 {
      color: #041120;
      font-weight: 900;
      line-height: 2.75rem;
      font-size: 2.25rem;
      margin-bottom: 2vh;
    }
    .flex.isMobile {
      flex-direction: column;
      .button {
        width: 35vw !important;
        padding-left: 3vw !important;
        padding-right: 3vw !important;
      }
    }
    .button {
      padding-left: 1vw;
      padding-right: 1vw;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 2vh;
      width: 20vw;
      height: 6vh;
      background: #fff;
      border: 1px solid #d9d9d9;
      box-shadow: 0 0 0 rgba(0, 0, 0, 0);
      transition: box-shadow 0.1s ease-in-out;
      div {
        display: flex;
        align-items: center;
        font-size: 16px;
        p {
          font-size: 16px;
        }
      }
      p {
        margin-bottom: 0;
        font-size: 11px;
      }
      &:hover {
        box-shadow: 1px 2px 3px #dcdcdc, 0 2px 3px #bae0ff;
        color: #1890ff;
        border: 1px solid #1890ff;
        box-shadow: 2px 3px 2px #bae0ff;
      }
    }
    .button-text {
      color: #999aaa;
      font-size: 0.8rem;
      margin-top: 1vh;
      width: 150px;
      text-align: center;
    }
    .search {
      line-height: 1.5rem;
      width: 50%;
      margin-top: 4vh;
      .addon {
        font-size: 16px;
      }
    }
  }
  .footer {
    // background: #f1efed;
    height: 35px;
    display: flex;
    align-items: center;
    justify-content: center;
    .version {
      text-align: right;
      padding-right: 8px;
    }
  }
}
</style>